export default "__VITE_ASSET__C2lDYiA9__"